import { pathOr, toLower, equals, and, not } from 'ramda';
import UserManageLoader from './UserManageLoader';
import SiteSettings from 'src/siteSetting';
import { STATUS_ACTIVE } from 'src/services/constants';
import { loginAccount } from 'src/features/Auth/Login/loginAccounts';
import { oauthCallBackReturnTo } from 'src/route_constants';
import { savedRedirectPath, unAuthenticatedUser } from 'src/utilities/storage';
import { updateUserSessionIntent } from 'src/features/core/ChatEngine/Bot/SimpleBotService';
import { isNotEmpty } from 'src/utilities/hasValue';

class AuthenticationManager {
  accountResource: any;
  args: any
  rememberMe?: any;

  constructor(accountResource: any, args: any, rememberMe?: any) {
    this.accountResource = accountResource;
    this.args = args;
    this.rememberMe = rememberMe;
  }


  verifyLogin(history: any) {
    const manageLoginTime = new UserManageLoader();
    const { redirectMeta,
      setSelectMFA,
      sendNotification,
      hasIntentUpdate,
      activeIntent,
      userSpecificIntent,
      returnTo
    } = this.args;

    const status = pathOr('', ['status'], this.accountResource);
    if (equals(toLower(status), toLower(STATUS_ACTIVE))) {
      manageLoginTime.setLoggedInTime();
      if (and(redirectMeta, not(returnTo && isNotEmpty(returnTo.match(/\/login/))))) {
        return this.redirectToExistPage(history)
      }
      const intentAnswer = pathOr('', ['phone'], this.accountResource) || pathOr('', ['email'], this.accountResource)
      if (hasIntentUpdate) {
        updateUserSessionIntent(
          activeIntent,
          userSpecificIntent,
          intentAnswer,
          true,     // hideStatus
          false, // isThisIntentActive
          //  ignore dispatch to avoid rerender before push to oauth
          false // shouldDispatch
        )
      }
      
      loginAccount(
        this.accountResource,
        history,
        this.rememberMe,
        null,
        unAuthenticatedUser.advisorUsername.get()
      );
      setSelectMFA && setSelectMFA(false);
    } else {
      sendNotification({
        msg: `Your account is suspended. Contact administrator in ${toLower(SiteSettings.generalAppTitle())} to restore your account.`,
        variant: 'error',
      });
    }
  }

  private redirectToExistPage(history: any) {
    const { returnTo, rememberMe } = this.args;
    /**
             * Save any returnTo link url in the savedRedirectPath in this session storage
             * This helps not use the query param across different routest
             * Currently used by view task in the borrower side
             */
    savedRedirectPath.set(returnTo);
    return history.push(
      oauthCallBackReturnTo(returnTo),
      {
        user: this.accountResource,
        rememberMe,
      }
    );
  }
}

export default AuthenticationManager;